<template>
  <button
      :class="{light: theme === 'light'}"
      class="theme-switch"
      type="button"
      @click="toggleTheme"
  >
      <span class="theme-switch-toggle"
      ></span>
    <svg
        class="theme-switch-icon moon"
        height="18" width="18"
    >
      <use xlink:href="/icons/sprite.svg#i-moon"></use>
    </svg>
    <svg
        class="theme-switch-icon sun"
        height="18" width="18"
    >
      <use xlink:href="/icons/sprite.svg#i-sun"></use>
    </svg>
  </button>
</template>

<script lang="ts" setup>
import {ref} from 'vue';
import {useFetch} from '#app';

const {data, error} = await useFetch('/api/theme')
const theme = ref(data.value?.theme || 'dark');

async function toggleTheme() {
  const newTheme = theme.value === 'light' ? 'dark' : 'light';
  const {data} = await useFetch<{ theme: string }>('/api/theme', {
    method: 'POST',
    body: {theme: newTheme},
  });
  if (data.value) {
    theme.value = data.value.theme;
    document.documentElement.setAttribute('data-theme', newTheme);
  }
}

watch(theme, (value) => {
  useHead({
    htmlAttrs: {
      'data-theme': theme.value,
    },
  });
}, {immediate: true});

onBeforeUnmount(() => {
  nextTick(() => {
    useHead({
      htmlAttrs: {
        'data-theme': 'dark',
      },
    });
  });
})
</script>

<style lang="scss" scoped>
.theme-switch {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 8px;
  background-color: var(--surfaces-high-container);
  border: none;
  border-radius: 100px;
  position: relative;
  cursor: pointer;

  &:focus {
    outline: 1px solid var(--accent-secondary);
  }

  &.light {
    background: #EBEDF0;

    .theme-switch-toggle {
      transform: translateX(31px);
    }
  }

  &-toggle {
    background-color: var(--accent-secondary);
    border-radius: 50%;
    position: absolute;
    width: 28px;
    height: 28px;
    top: 4px;
    left: 4px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
    transition: transform 300ms ease;
    padding: 4px;
  }

  &.light {
    .theme-switch-icon.sun {
      color: #fff;
    }

    .theme-switch-icon.moon {
      color: var(--surfaces-on-surface-variable);
    }
  }

  .theme-switch-icon.sun {
    color: var(--surfaces-on-surface-variable);
  }

  .theme-switch-icon.moon {
    color: #fff;
  }

  &-icon {
    width: 20px;
    height: 20px;
    position: relative;
    z-index: 1;
    transition: color 300ms ease;

    &.sun {
      position: relative;
      right: 0.5px;
    }
  }
}

</style>

